import OpcionDashboard from "../../components/organisms/OpcionDashboard";

function Dashboard() {
    return(
        <OpcionDashboard/>
    );
}
export default Dashboard;

